import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { Grid } from '@mui/material';

import MfproductPageImpl from './MfproductPageImpl';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function MfproductPage() {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(openDrawer({drawerOpen:true}));
    },[]);

    return (
        < MfproductPageImpl />
    )

}